/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadOfferDocumentsResponse
 */
export interface UploadOfferDocumentsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadOfferDocumentsResponse
     */
    documentIds: Array<string>;
}

/**
 * Check if a given object implements the UploadOfferDocumentsResponse interface.
 */
export function instanceOfUploadOfferDocumentsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentIds" in value;

    return isInstance;
}

export function UploadOfferDocumentsResponseFromJSON(json: any): UploadOfferDocumentsResponse {
    return UploadOfferDocumentsResponseFromJSONTyped(json, false);
}

export function UploadOfferDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadOfferDocumentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentIds': json['document_ids'],
    };
}

export function UploadOfferDocumentsResponseToJSON(value?: UploadOfferDocumentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_ids': value.documentIds,
    };
}

